import { capitalizeFirstLetter } from 'utils'
import { memo } from 'react'

import Text from 'common-components/Text'

import * as Styled from './styled'
import { TTextType } from 'common-components/Text/types'
import { TColorKey } from 'types'

import BackArrowIcon from 'assets/svgr-icons/Back_Arrow.svg'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

interface IProps {
  label?: string
  className?: string
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  color?: TColorKey
  textType?: TTextType
  gap?: number
}

const BackButton: React.FC<IProps> = props => {
  const {
    label = translate(T.BACK),
    className,
    onClick,
    color = 'secondarySemiDark',
    textType = 'h4',
    gap = 8
  } = props

  return (
    <Styled.BackButton $gap={gap} onClick={onClick} className={className}>
      <Styled.BackButtonIconWrapper>
        <BackArrowIcon />
      </Styled.BackButtonIconWrapper>
      <Text type={textType} color={color}>
        {capitalizeFirstLetter(label)}
      </Text>
    </Styled.BackButton>
  )
}

export default memo(BackButton)
